import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$alias/settings/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$alias/settings/profile',
      params: {
        alias: params.alias,
      },
      search,
      replace: true,
    })
  },
})
